import React, { Fragment } from 'react'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'


const portfolioErrorMessages = {
  label: `We're experiencing a tech glitch right now.`,
  subLabel: (
    <Fragment>
      We&apos;re not able to display your balance and portfolio details at the moment.
      If you&apos;d like an update now, please <PrivateWealthEmailLink message="let your team know" /> and we&apos;ll help
    </Fragment>
  )
}

const documentsErrorMessages = {
  label: 'There’s a problem loading your documents.',
  subLabel: (
    <Fragment>
      We’re working on resolving the issue. Until we’re back up,
      <PrivateWealthEmailLink message="contact your team" /> to manage your documents.
    </Fragment>
  )
}

const accountListErrorMessage = {
  label: 'Your accounts are unavailable',
  subLabel: (
    <Fragment>
     We’re having a problem displaying your accounts right now.
     Please <PrivateWealthEmailLink message="contact your team" /> for help.
    </Fragment>
  )
}

export const errorMessagesByContext = {
  portfolio: portfolioErrorMessages,
  documents: documentsErrorMessages,
  accountList: accountListErrorMessage
}

export default {
  errorMessagesByContext
}



// WEBPACK FOOTER //
// ./src/utils/Client/technicalDifficultiesMessage.js